"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defineClientPlugin = void 0;
/**
 * Derives the `id` from the plugin's `package.json` so it isn't
 * duplicated across files.
 *
 * @param pkg The plugin's `package.json` (imported as JSON).
 * @param def The plugin definition, minus `id`.
 * @returns A `ClientPlugin` with `id` set from `pkg.name`.
 * @throws If `pkg.name` is missing or empty.
 *
 * @example
 * ```ts
 * import { defineClientPlugin } from "@cc-plugins/api";
 * import pkg from "../../package.json";
 *
 * export default defineClientPlugin(pkg, {
 *   reducers: { ... },
 *   ui: [ ... ],
 * });
 * ```
 */
const defineClientPlugin = (pkg, def) => {
    if (!pkg.name) {
        throw new Error("defineClientPlugin: package.json must have a non-empty 'name'");
    }
    return Object.assign({ id: pkg.name }, def);
};
exports.defineClientPlugin = defineClientPlugin;
